<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance' }">Finance</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance report'}">
          {{ $root.getHeader() }} Finance Accrual Report
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-card shadow="never">
      <template slot="header">
        <el-row type="flex" justify="space-between" align="middle">
          <el-col :span="8">
            <el-date-picker
              v-model="date"
              type="month"
              placeholder="Pick a month"
              @change="refreshData"
              style="width: 100%"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="12">
            <el-button-group>
              <el-popover
                ref="yearExportPopover"
                placement="bottom"
                width="300"
                trigger="manual"
                v-model="yearExportVisible"
              >
                <FileDownloadStatus :files="yearExportFiles" />
                <el-button
                  icon="el-icon-download"
                  @click="exportYear"
                  :disabled="loading"
                  slot="reference"
                >
                  Export Year Report
                </el-button>
              </el-popover>
              <el-popover
                ref="monthExportPopover"
                placement="bottom"
                width="300"
                trigger="manual"
                v-model="monthExportVisible"
              >
                <FileDownloadStatus :files="monthExportFiles" />
                <el-button
                  icon="el-icon-download"
                  @click="exportMonth"
                  :disabled="loading"
                  slot="reference"
                >
                  Export Month Report
                </el-button>
              </el-popover>
            </el-button-group>
          </el-col>
          <el-col :span="16" style="text-align: right">
            <el-button
              type="primary"
              plain
              icon="el-icon-document"
              @click="getAccountingReport"
              :loading="reportLoading"
              style="margin-left: 10px"
            >
              Get Master Accounting Report
            </el-button>
          </el-col>
        </el-row>
      </template>
      <el-tabs v-model="activeTab" tab-position="top">
        <el-tab-pane lazy label="Accrual" name="accrual">
          <el-row type="flex" :gutter="20">
            <el-col :span="12">
              <el-card
                v-loading="loading"
                shadow="never"
                :body-style="{background: 'linear-gradient(35deg, #009aca, #0c3da7)', padding: '20px' }">
                <div slot="header" class="wallet-header">
                  <p class="wallet-head">
                    Rent Billed
                    <i v-if="locked" class="el-icon-lock"></i>
                  </p>
                </div>
                <h4 class="wallet-text">
                  {{ totalRent | currencySign($root.state.facilityData) }}
                </h4>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card
                shadow="never"
                v-loading="loading"
                :body-style="{background: 'linear-gradient(35deg, #009aca, #0c3da7)', padding: '20px' }">
                <div slot="header" class="wallet-header">
                  <p class="wallet-head">
                    Fees Billed
                    <i v-if="locked" class="el-icon-lock"></i>
                  </p>
                </div>
                <h4 class="wallet-text">
                  {{ totalFees | currencySign($root.state.facilityData)  }}
                </h4>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card
                shadow="never"
                v-loading="loading"
                :body-style="{background: 'linear-gradient(35deg, #009aca, #0c3da7)', padding: '20px' }">
                <div slot="header" class="wallet-header">
                  <p class="wallet-head">
                    Adjustments
                    <i v-if="locked" class="el-icon-lock"></i>
                  </p>
                </div>
                <h4 class="wallet-text">
                  {{ totalAdjustments | currencySign($root.state.facilityData)  }}
                </h4>
              </el-card>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row type="flex" :gutter="20">
            <el-col :span="12">
              <el-card shadow="never" v-loading="loading">
                <template slot="header">
                  Rent Items
                  <i v-if="locked" class="el-icon-lock"></i>
                </template>
                <el-table :data="rentItems" @row-click="routeToCustomer">
                  <el-table-column label="Created At">
                    <template slot-scope="scope">
                      {{ scope.row.createdAt | formatDate }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="description" label="Description"></el-table-column>
                  <el-table-column prop="lease.customerId.company" label="Customer"></el-table-column>
                  <el-table-column label="Amount" prop="amount" :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"></el-table-column>
                </el-table>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card shadow="never" v-loading="loading">
                <template slot="header">
                  Fee Items
                  <i v-if="locked" class="el-icon-lock"></i>
                </template>
                <el-table :data="feeItems" @row-click="routeToCustomer">
                  <el-table-column label="Created At">
                    <template slot-scope="scope">
                      {{ scope.row.createdAt | formatDate }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="description" label="Description"></el-table-column>
                  <el-table-column prop="feeType" label="Type"></el-table-column>
                  <el-table-column label="Customer">
                    <template slot-scope="scope">
                      <span v-if="scope.row.customer && scope.row.customer.company">
                        {{  scope.row.customer.company }}
                      </span>
                      <span v-else-if="scope.row.lease">
                        {{  scope.row.lease.customerId.company }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Amount"
                    prop="amount"
                    :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
                  ></el-table-column>
                </el-table>
              </el-card>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row type="flex" :gutter="20">
            <el-col :span="12">
              <el-card shadow="never" v-loading="loading">
                <template slot="header">
                  Rental Adjustments
                  <i v-if="locked" class="el-icon-lock"></i>
                </template>
                <el-table :data="rentalAdjustments" @row-click="routeToCustomer">
                  <el-table-column label="Created At">
                    <template slot-scope="scope">
                      {{ scope.row.createdAt | formatDate }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="description" label="Description"></el-table-column>
                  <el-table-column prop="type" label="Adj Type"></el-table-column>
                  <el-table-column prop="customer.company" label="Customer"></el-table-column>
                  <el-table-column label="Amount" prop="amount" :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"></el-table-column>
                </el-table>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card shadow="never" v-loading="loading">
                <template slot="header">
                  Fee Adjustments
                  <i v-if="locked" class="el-icon-lock"></i>
                </template>
                <el-table :data="feeAdjustments" @row-click="routeToCustomer">
                  <el-table-column label="Created At">
                    <template slot-scope="scope">
                      {{ scope.row.createdAt | formatDate }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="description" label="Description"></el-table-column>
                  <el-table-column prop="feeType" label="Type"></el-table-column>
                  <el-table-column prop="type" label="Adj Type"></el-table-column>
                  <el-table-column prop="customer.company" label="Customer"></el-table-column>
                  <el-table-column
                    label="Amount"
                    prop="amount"
                    :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
                  ></el-table-column>
                </el-table>
              </el-card>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row type="flex" :gutter="20">
            <el-col :span="12">
              <el-card shadow="never" v-loading="loading">
                <template slot="header">
                  CC Fee Adjustments
                  <i v-if="locked" class="el-icon-lock"></i>
                </template>
                <el-table :data="ccAdjustments" @row-click="routeToCustomer">
                  <el-table-column label="Created At">
                    <template slot-scope="scope">
                      {{ scope.row.createdAt | formatDate }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="description" label="Description"></el-table-column>
                  <el-table-column prop="feeType" label="Type"></el-table-column>
                  <el-table-column prop="customer.company" label="Customer"></el-table-column>
                  <el-table-column prop="type" label="Adj Type"></el-table-column>
                  <el-table-column
                    label="Amount"
                    prop="amount"
                    :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
                  ></el-table-column>
                </el-table>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane lazy label="Write Off" name="writeOff">
          <el-row type="flex" :gutter="20">
            <el-col>
              <el-card shadow="never" v-loading="loading">
                <el-table :data="transactions" @row-click="routeToCustomer">
                  <el-table-column
                    label="Created At"
                    prop="createdAt"
                    :formatter="(row, column, cellValue ) => $options.filters.formatDate(cellValue)"
                    >
                  </el-table-column>
                  <el-table-column label="Customer" prop="customer.company"></el-table-column>
                  <el-table-column label="Type" prop="type"></el-table-column>
                  <el-table-column label="Description" prop="details">
                  </el-table-column>
                  <el-table-column label="Created By" prop="createdBy" :width="200">
                  </el-table-column>
                  <el-table-column
                    label="Amount" prop="amount"
                    :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
                  ></el-table-column>
                </el-table>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </el-card>
</template>

<script>
import axios from 'axios';
import FileDownloadStatus from './FileDownloadStatus';
import { ADMIN_API_BASE, ACCRUAL_API_BASE, ORG_API, AUDIT_API } from '../env';
import getMonthAndYear from '../utils/timing';
import { exportToCsvV2, saveCsv } from '../utils/exportToCsv';


export default {
  name: 'FinanceAccruals',
  components: {
    FileDownloadStatus,
  },
  props: { facility: { type: String } },
  watch: {
    async facility() {
      this.facilityData = this.$root.state.facilityData;
      await this.getReport();
      await this.getTransactions();
    },
  },
  async mounted() {
    this.facilityData = this.$root.state.facilityData;
    await this.getFacilities();
    await this.fetchOrgFeeTypes();
    await this.getTransactions();
    await this.getReport();
  },
  data() {
    return {
      reportLoading: false,
      facilityIdNameMap: {},
      loading: false,
      locked: false,
      rentItems: [],
      feeItems: [],
      totalRent: 0,
      totalFees: 0,
      totalRentalAdjustments: 0,
      totalAdjustments: 0,
      date: new Date(),
      unitTypeData: [],
      feeTypeData: [],
      rentItemsData: [],
      rentalAdjustments: [],
      feeAdjustments: [],
      ccAdjustments: [],
      feeItemsData: [],
      transactions: [],
      activeTab: 'accrual',
      org: {},
      yearExportVisible: false,
      monthExportVisible: false,
      yearExportFiles: [],
      monthExportFiles: [],
    };
  },
  computed: {
    allYearExportsCompleted() {
      return this.yearExportFiles.length > 0 && this.yearExportFiles.every(file => file.status === 'completed' || file.status === 'error');
    },
    allMonthExportsCompleted() {
      return this.monthExportFiles.length > 0 && this.monthExportFiles.every(file => file.status === 'completed' || file.status === 'error');
    },
  },
  methods: {
    getAccrualReportFilename(exportType) {
      const facilityCode = this.$root.state.facilityData.code;
      if (exportType === 'year') {
        return `${facilityCode} Accrual Report YTD ${this.date.getFullYear()}`;
      }

      const monthYear = getMonthAndYear(this.date).replace(',', '');
      return `${facilityCode} Accrual Report Monthly ${monthYear}`;
    },

    getSummaryReportFilename(exportType) {
      const year = this.date.getFullYear();
      const facilityCode = this.$root.state.facilityData.code;
      if (exportType === 'year') {
        return `${facilityCode} Accrual Summary Report YTD ${year}`;
      }

      const monthYear = getMonthAndYear(this.date).replace(',', '');
      return `${facilityCode} Accrual Summary Report Monthly ${monthYear}`;
    },
    async exportYear() {
      this.initializeYearExport();

      try {
        await this.getItemsForCSV('year');
        this.updateYearExportFileStatus(this.getAccrualReportFilename('year'), 'completed');
      } catch (error) {
        this.updateYearExportFileStatus(this.getAccrualReportFilename('year'), 'error');
      }

      try {
        await this.getSummaryReportForCSV('year');
        this.updateYearExportFileStatus(this.getSummaryReportFilename('year'), 'completed');
      } catch (error) {
        this.updateYearExportFileStatus(this.getSummaryReportFilename('year'), 'error');
      }

      // Auto-hide popover after 3 seconds if all completed
      setTimeout(() => {
        if (this.allYearExportsCompleted) {
          this.yearExportVisible = false;
        }
      }, 3000);
    },
    async exportMonth() {
      this.initializeMonthExport();

      try {
        await this.getItemsForCSV('month');
        this.updateMonthExportFileStatus(this.getAccrualReportFilename('month'), 'completed');
      } catch (error) {
        this.updateMonthExportFileStatus(this.getAccrualReportFilename('month'), 'error');
      }

      try {
        await this.getSummaryReportForCSV('month');
        this.updateMonthExportFileStatus(this.getSummaryReportFilename('month'), 'completed');
      } catch (error) {
        this.updateMonthExportFileStatus(this.getSummaryReportFilename('month'), 'error');
      }

      // Auto-hide popover after 3 seconds if all completed
      setTimeout(() => {
        if (this.allMonthExportsCompleted) {
          this.monthExportVisible = false;
        }
      }, 3000);
    },
    initializeYearExport() {
      this.yearExportFiles = [
        { name: this.getAccrualReportFilename('year'), status: 'loading' },
        { name: this.getSummaryReportFilename('year'), status: 'loading' }
      ];
      this.yearExportVisible = true;
    },
    initializeMonthExport() {
      this.monthExportFiles = [
        { name: this.getAccrualReportFilename('month'), status: 'loading' },
        { name: this.getSummaryReportFilename('month'), status: 'loading' }
      ];
      this.monthExportVisible = true;
    },
    updateYearExportFileStatus(fileName, status) {
      const file = this.yearExportFiles.find(f => f.name === fileName);
      if (file) {
        file.status = status;
      }
    },
    updateMonthExportFileStatus(fileName, status) {
      const file = this.monthExportFiles.find(f => f.name === fileName);
      if (file) {
        file.status = status;
      }
    },
    async getTransactions() {
      this.loading = true;
      const response = await axios.get(`${AUDIT_API}/${this.facility}/write/off/transactions`, {
        params: {
          ...(this.date ? {
            month: this.date.getMonth(),
            year: this.date.getFullYear(),
          } : {}),
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.transactions = response.data.result.transactions;
      this.loading = false;
    },
    async getFacilities() {
      try {
        const response = await axios.get(`${ADMIN_API_BASE}/facilities/portal`, {
          params: {
            limit: 50,
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.loading = false;

        for (const facility of response.data) {
          this.facilityIdNameMap[facility._id] = facility.title;
        }
      } catch (err) {
        this.loading = false;
        this.$message.error({ message: 'Error loading facility data' });
      }
    },
    async refreshData() {
      await this.getReport();
      await this.getTransactions();
    },
    getTaxItemAmountForAccrualItem(item) {
      const lease = item.lease;
      if (!lease) { return 0; }

      if (!lease.lineItems || !lease.lineItems.length) { return 0; }
      const lineItem = lease.lineItems.find(creditItem => creditItem._id === item._id);
      if (!lineItem) { return 0; }
      if (!lineItem.uniqId) { return 0; }

      const taxItem = lease.lineItems.find(creditItem => creditItem.source === lineItem.uniqId);
      if (!taxItem) { return 0; }

      return taxItem.amount || 0;
    },
    async getReport() {
      this.unitTypeData.length = 0;
      this.feeTypeData.length = 0;
      this.loading = true;
      const response = await axios.get(`${ACCRUAL_API_BASE}/${this.facility}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
        params: {
          month: this.date.getMonth(),
          year: this.date.getFullYear(),
          offset: new Date().getTimezoneOffset(),
        },
      });

      this.rentItems = response.data.result.rentItems;
      this.feeItems = response.data.result.feeItems;
      this.totalRent = response.data.result.totalRent;
      this.totalFees = response.data.result.totalFees;
      this.totalRentalAdjustments = response.data.result.totalRentalAdjustments;
      this.totalAdjustments = response.data.result.totalRentalAdjustments + response.data.result.totalCcFeeAdjustments + response.data.result.totalFeeAdjustments;
      this.rentalAdjustments = response.data.result.rentalAdjustments;
      this.feeAdjustments = response.data.result.feeAdjustments;
      this.ccAdjustments = response.data.result.ccAdjustments;
      this.locked = response.data.result.report;

      this.loading = false;
    },
    async fetchOrgFeeTypes() {
      const response = await axios.get(`${ORG_API}/fee/types`, {
        headers: { Authorization: `Bearer ${this.$keycloak.token}` }
      });

      this.org.feeTypes = response.data;
    },
    async getAccountingReport() {
      this.reportLoading = true;

      const report = await axios.get(`${ACCRUAL_API_BASE}/master-accounting`, {
        params: {
          year: this.date.getFullYear(),
          month: this.date.getMonth(),
        },
        headers: { Authorization: `Bearer ${this.$keycloak.token}` },
      });

      if (!report.data.length) {
        this.reportLoading = false;
        this.$message.warning({
          message: 'Report does not exist',
        });
        return;
      }

      report.data.filter((item) => {
        if (!item.writeoffPayment) {
          item.writeoffPayment = 0;
        }
      });

      const reportHeaderMap = {
        facility: 'Facility',
        warehouseOfficeRevenue: 'Warehouse+Office Revenue',
        parkingRevenue: 'Parking Revenue',
        adjustments: 'Past Period Adjustments',
        salesTax: 'Sales Tax',
        ccFee: 'CC Convenience',
        constructionImprovements: 'Construction/Improvements',
        utilityIncome: 'Utility Income',
        damage: 'Damage',
        security: 'Security',
        hourlyLabour: 'Hourly Labour',
        penaltiesViolations: 'Penalties/Violations',
        lateFee: 'Late Fee',
        otherFees: 'All Other Fee Types',
        depositOnHand: 'Deposits On Hand',
        changePMDeposits: 'Change Prior Month Deposits',
        prepaidHeldFunds: 'Prepaid/Held Funds',
        changePMPHFunds: 'Change P/H PM',
        totalReceivables: 'Receivables',
        changeReceivPM: 'Change Receiv PM',
        creditWithoutPayment: 'Credit Without Payment',
        writeoffPayment: 'Write Off Payment',
      };

      for (const row of report.data) {
        if (!row.adjustments) {
          row.adjustments = 0;
        }
        row.facility = this.facilityIdNameMap[row.facility];
      }
      report.data.sort((row1, row2) => row1.facility.localeCompare(row2.facility));

      try {
        const reportCSV = exportToCsvV2({
          ...reportHeaderMap,
        }, report.data);

        saveCsv(reportCSV, `Master_Accounting_Report_${getMonthAndYear(this.date)}`);
      } catch (error) {
        this.$message.error({
          message: 'There was an error downloading the report',
        });
      }
      this.reportLoading = false;
    },
    async getSummaryReportForCSV(exportType = 'year') {
      try {
        const year = this.date.getFullYear();
        const month = this.date.getMonth();
        const csvData = [];

        const rowDefinitions = [
          { key: 'warehouseOfficeRevenue', label: 'Warehouse+Office Revenue' },
          { key: 'parkingRevenue', label: 'Parking Revenue' },
          { key: 'adjustments', label: 'Past Period Adjustments' },
          { key: 'salesTax', label: 'Sales Tax' },
          { key: 'ccFee', label: 'CC Convenience' },
          { key: 'constructionImprovements', label: 'Construction/Improvements' },
          { key: 'utilityIncome', label: 'Utility Income' },
          { key: 'damage', label: 'Damage' },
          { key: 'security', label: 'Security' },
          { key: 'hourlyLabour', label: 'Hourly Labour' },
          { key: 'penaltiesViolations', label: 'Penalties/Violations' },
          { key: 'lateFee', label: 'Late Fee' },
          { key: 'otherFees', label: 'All Other Fee Types' },
          { key: 'creditWithoutPayment', label: 'Credit Without Payment' },
          { key: 'writeoffPayment', label: 'Write Off Payment' },
        ];

        // Fetch data with conditional month parameter
        const response = await axios.get(`${ACCRUAL_API_BASE}/${this.facility}/summary-export-items`, {
          params: {
            year,
            ...(exportType === 'month' ? { month } : {}),
          },
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        });

        if (response.status !== 200 || !response.data.result.length) {
          this.loading = false;
          this.$message.warning({
            message: 'Report does not exist for the selected period',
          });
          return;
        }
        const items = response.data.result;

        // Create CSV rows for year view - each element in response.data represents a month's report
        for (const rowDef of rowDefinitions) {
          const row = { 'Category': rowDef.label };

          // Go through each month's report and add columns
          items.forEach((monthReport) => {
            const monthNames = ['', 'January', 'February', 'March', 'April', 'May', 'June',
                                'July', 'August', 'September', 'October', 'November', 'December'];
            const monthName = monthNames[monthReport.month];
            row[monthName] = monthReport[rowDef.key] || 0;
          });

          csvData.push(row);
        }

        // Define CSV headers for year view - create headers for each month in the data
        const csvHeaders = { 'Category': 'Category' };
        const monthNames = ['', 'January', 'February', 'March', 'April', 'May', 'June',
                            'July', 'August', 'September', 'October', 'November', 'December'];

        // Add headers for months that have data
        items.forEach((monthReport) => {
          const monthName = monthNames[monthReport.month];
          csvHeaders[monthName] = monthName;
        });

        // Generate CSV and save file
        const csv = exportToCsvV2(csvHeaders, csvData);
        saveCsv(csv, this.getSummaryReportFilename(exportType));

      } catch (error) {
        this.$message.error({
          message: 'Error generating master accounting report export',
        });
        console.error('Export error:', error);
        throw error;
      }
    },
    async getItemsForCSV(exportType = 'month') {
      let exportData = {};

      try {
        // Fetch month data from export endpoint
        const response = await axios.get(`${ACCRUAL_API_BASE}/${this.facility}/export-items`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
          params: {
            ...(exportType === 'month' ? { month: this.date.getMonth() } : {}),
            year: this.date.getFullYear(),
          },
        });
        if (response.status === 400) {
          this.$message.error({
            title: 'Not found',
            message: 'Accrual reports not found for the given period.',
          });
          return;
        }
        exportData = response.data.result;

        const allAccrualCsvItems = exportData.map(item => ({
          CreatedAt: this.$options.filters.formatDate(item.createdAt),
          Period: item.period,
          Type: item.type,
          Description: (item.description || '').replace(/,/g, ''),
          Customer: (item.customer || '').replace(/,/g, ''),
          Amount: Number(item.amount || 0).toLocaleString('en', { style: 'currency', currency: this.$root.state.facilityData.pricing.currency }).replace(/,/g, ''),
        }));

        // Generate CSV
        const accrualReportCsv = exportToCsvV2({
          CreatedAt: 'Created At',
          Period: 'Period',
          Type: 'Type',
          Description: 'Description',
          Customer: 'Customer',
          Amount: 'Amount',
        }, allAccrualCsvItems);

        // Generate filename and save
        saveCsv(accrualReportCsv, this.getAccrualReportFilename(exportType));

      } catch (error) {
        this.$message.error({
          message: 'Error generating accrual report export',
        });
        console.error('Export error:', error);
        throw error;
      }
    },
    routeToCustomer(row) {
      if (this.facility) {
        this.$router.push({ name: 'Facility Customer', params: { id: row.lease && row.lease.customerId ? row.lease.customerId._id : row.customer._id, facility: this.facility } });
        return;
      }
      this.$router.push({ name: 'Customer', params: { id: row.lease && row.lease.customerId ? row.lease.customerId._id : row.customer._id } });
    },
  },
};
</script>

<style scoped>
.wallet {
  width: 480px;
}

.wallet-text {
  color: #efefef;
  font-weight: 300;
}

.wallet-head {
  font-weight: 400;
  margin: 0;
  color: #009aca;
}

.card {
  margin-bottom: 20px;
}

.image {
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/FinanceAccrual.vue